import React from 'react';
import { StyledGeoValue } from './styled';

const GeoDataRenderer = ({ cellData }) => (
  <StyledGeoValue>
    {cellData}
  </StyledGeoValue>
);

export default GeoDataRenderer;
